module.exports = __webpack_public_path__ + "static/how-it-works-df59b91c2c8093239b16b1ab3b5da9d9.gif";